export default {
  onlineNotif: Object.freeze({APP_NEW_LEADS_LOCAL_STORAGE_KEY: 'new-leads'}),
}
